import React, { useRef, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { ReactToPrint, useReactToPrint } from "react-to-print";
import NumberFormat from "react-number-format";
import { mdiPrinterSettings, mdiFileExcel, mdiMicrosoftExcel } from "@mdi/js";
import Icon from "@mdi/react";
import moment from "moment";
import { Cookies } from "react-cookie";
import { Index_getConfigByKey } from "actions/DanhMuc";
import configs from "constants/configs";
import { getBranch } from "utils/utils";
import { convertDate } from "utils/currencyFormat";
import { getUserLogin } from "utils/utils";
import nhaphangApi from "service/nhaphangApi";
import LayoutNew from "common/LayoutNoLogin";
import PageNotRole from "components/ComponentImport/PageNotRole";
import DatHangApi from "service/DatHang/DatHangApi";
var numeral = require("numeral");

class ComponentToPrint extends React.Component {
    render() {
        const HrLine = ({ color }) => (
            <hr
                style={{
                    color: color,
                    backgroundColor: color,
                    height: 1,
                    margin: 2,
                }}
            />
        );
        return (
            <div
                style={{
                    backgroundColor: "#ffffff",
                    marginBottom: "50px",
                    height: "fit-content", //fix lỗi giãn dòng khi in
                    padding: "20px",
                }}
                id="htmlPrint"
                className="textPrint-TrangIn dailyin"
            >
                <div dangerouslySetInnerHTML={{ __html: this.props.DataSend }} />
                <footer
                    style={{
                        position: "fixed",
                        bottom: "0px",
                        color: "#EEEEEE",
                        fontSize: "10px",
                        fontWeight: "unset",
                    }}
                >
                    <span
                        style={{
                            color: "#EEEEEE",
                            fontSize: "10px",
                            fontWeight: "unset",
                        }}
                    >
                        Phần Mềm Quản Lý sản xuất & kinh doanh - Niềm Tin, SĐT :
                        0328.666.932
                    </span>
                </footer>
            </div>
        );
    }
}

export const RpDatHangDaiLyNgoai = (props) => {

    var html = "";
    const [dataInNhapHang, setDataInNhapHang] = useState(html);
    const [isStartProcess, setIsStartProcess] = useState(false);
    //sửa
    let search = window.location.search;
    let params = new URLSearchParams(search);
    let DatHangID = params.get("DatHangID");
    useEffect(() => {
        setIsStartProcess(true);
        DatHangApi.PrintChiTietDonHangDaiLy(
            DatHangID, "", false
        ).then((response) => {
            if (response.status === 200) {
                if (response.data) {
                    setDataInNhapHang(response.data.htmpPrint)
                }
            }
            setIsStartProcess(false);
        });
    }, []);
    const printButtonRef = useRef(null);
    const componentRef = useRef();
    const user = useSelector((state) => state.user);


    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.ctrlKey && event.key.toLowerCase() === "p") {
                event.preventDefault(); // Ngăn chặn hành vi mặc định (mở hộp thoại "Save As")

                if (printButtonRef.current) {
                    printButtonRef.current.click(); // Kích hoạt sự kiện click của nút
                }
            }
        };

        window.addEventListener("keydown", handleKeyDown);
        return () => {
            window.removeEventListener("keydown", handleKeyDown);
        };
    }, []);
    const danhmuc = useSelector((state) => state.danhmuc);
    const XuatExcel = () => {
        var uri =
            "data:application/vnd.ms-excel," +
            encodeURIComponent(document.getElementById("htmlPrint").outerHTML);
        var downloadLink = document.createElement("a");
        downloadLink.href = uri;
        downloadLink.download =
            "DatHangDaiLy" + moment().format("YYYYMMDDHHmm") + ".xls";
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
    };
    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
        // copyStyles: false,
        pageStyle: `
            @page { margin: 10mm; }
        `,
    });
    return (
        <LayoutNew isPrint={true} isProgress={isStartProcess}>
            {/* {roleTinhNang != null ? (
                <div>
                    {roleTinhNang ? ( */}
            <>
                <>
                    <ComponentToPrint
                        ref={componentRef}
                        DataSend={dataInNhapHang}
                        ThongTinIn={danhmuc.objConfig}
                    />

                    <div
                        class="fixed"
                        style={{ width: "100%", left: "0px", paddingRight: "30px" }}
                    >
                        <div style={{ width: "100%", clear: "both" }}>
                            <div
                                style={{
                                    marginTop: "25px",
                                    float: "right",
                                    display: "flex",
                                }}
                            >
                                {/* {roleInXuatExcel && ( */}
                                <>
                                    <a
                                        class="button-Add-NoIcon bg-blue-main"
                                        href=""
                                        onClick={XuatExcel}
                                    >
                                        <Icon
                                            path={mdiMicrosoftExcel}
                                            title="In"
                                            size={1.4}
                                            color="white"
                                        />
                                        &nbsp; Xuất excel{" "}
                                    </a>{" "}
                                    &nbsp;&nbsp;&nbsp;&nbsp;
                                    <button
                                        class="button-Add-NoIcon bg-blue-main"
                                        onClick={handlePrint}
                                        ref={printButtonRef}
                                    >
                                        <Icon
                                            path={mdiPrinterSettings}
                                            title="In"
                                            size={1.4}
                                            color="white"
                                        />
                                        &nbsp; In đơn
                                    </button>
                                </>
                                {/* )} */}
                            </div>
                        </div>
                    </div>
                </>
            </>
            {/* ) : (
                        <PageNotRole />
                    )}
                </div>
            ) : (
                <div></div>
            )} */}
        </LayoutNew>
    );
};
